import React from 'react';

import InputSelect from '../Components/FormFields/Select';
import InputText from '../Components/FormFields/Text';
import InputTextArea from '../Components/FormFields/TextArea';
import InputNumber from '../Components/FormFields/Number';
import InputCurrency from '../Components/FormFields/Currency';
import InputDate from '../Components/FormFields/Date';
import InputDateTime from '../Components/FormFields/DateTime';
import InputTime from '../Components/FormFields/Time';

class ConditionalFields {
  static getValueInput = (field, onChange, onError, data, optionIndex, fieldLabel = 'Value...', valueLabel = 'conditionValue', valueType = 'conditionType') => {
    const value = data ? data[valueLabel] : null;
    const type = data ? data[valueType] && data[valueType]['value'] : null;
    let options = [];
    switch (field.component) {
      case 'textArea':
        if (type == 'Is Empty' || type == 'Is Not Empty') {
          return false;
        }
        else {
          return (
            <InputTextArea
              label={fieldLabel}
              required
              value={value}
              onChange={(v) => onChange(v)}
              error={data.errors[valueLabel]}
              onError={(er) => onError(er)}
            />
          );
        }
      case 'checkbox':
      case 'checkboxJustifiedLeft':
        if (type == 'Is Empty' || type == 'Is Not Empty') {
          return false;
        }
        else {
          options = field.options.map((item, index) => {
            return { value: optionIndex ? index.toString() : item.value, label: item.value };
          });
          return (
            <InputSelect
              options={options}
              label={fieldLabel}
              required
              value={value}
              multiple
              onChange={(v) => onChange(v)}
              error={data.errors[valueLabel]}
              onError={(er) => onError(er)}
            />
          );
        }
      case 'radio':
      case 'radioJustifiedLeft':
      case 'select':
      case 'ratingScale3pt':
        options = field.options.map((item, index) => {
          return { value: optionIndex ? index.toString() : item.value, label: item.value };
        });
        return (
          <InputSelect
            options={options}
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'numberInput':
      case 'sliderRange':
      case 'starRate':
        return (
          <InputNumber
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'currencyInput':
        return (
          <InputCurrency
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'dateInput':
        return (
          <InputDate
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'dateTimeInput':
        return (
          <InputDateTime
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'timeInput':
        return (
          <InputTime
            label={fieldLabel}
            required
            value={value}
            onChange={(v) => onChange(v)}
            error={data.errors[valueLabel]}
            onError={(er) => onError(er)}
          />
        );
      case 'fileImageInput':
      case 'fileInput':
      case 'imageInput':
      case 'imageMultipleInput':
      case 'signatureInput':
      case 'freeText':
      case 'fileEmbedded':
        return false;
      default:
        if (type == 'Is Empty' || type == 'Is Not Empty') {
          return false;
        }
        else {
          return (
            <InputText
              label={fieldLabel}
              required
              value={value}
              onChange={(v) => onChange(v)}
              error={data.errors[valueLabel]}
              onError={(er) => onError(er)}
            />
          );
        }
    }
  };

  static getOptions = (field) => {
    if (!field) return [];
    switch (field.component) {
      case 'textInput':
      case 'phoneInput':
      case 'textArea':
      case 'propertyInfo':
      case 'propertyName':
      case 'propertyAddress':
      case 'unitInfo':
      case 'unitNumber':
      case 'unitBuilding':
      case 'checkbox':
      case 'checkboxJustifiedLeft':
        return [
          { label: 'Equals', value: 'Equals' },
          { label: 'Contains', value: 'Contains' },
          { label: 'Is Empty', value: 'Is Empty' },
          { label: 'Is Not Empty', value: 'Is Not Empty' }
        ];
      case 'radio':
      case 'radioJustifiedLeft':
      case 'select':
      case 'ratingScale3pt':
        return [{ label: 'Equals', value: 'Equals' }];
      case 'numberInput':
      case 'sliderRange':
      case 'starRate':
      case 'currencyInput':
      case 'dateInput':
      case 'dateTimeInput':
      case 'timeInput':
        return [
          { label: 'Minor', value: 'Minor' },
          { label: 'Minor and Equals', value: 'Minor and Equals' },
          { label: 'Equals', value: 'Equals' },
          { label: 'Major and Equals', value: 'Major and Equals' },
          { label: 'Major', value: 'Major' }
        ];
      default:
        return [
          { label: 'Is Empty', value: 'Is Empty' },
          { label: 'Is Not Empty', value: 'Is Not Empty' }
        ];
    }
  };
}

export default ConditionalFields;
